// Lightweight procurement constants — no Drizzle/schema dependencies
// Safe for both client and server imports

// Values align with CREDIT_TYPES from @forestsync/db — used for procurement mandate filtering
export const KNOWN_METHODOLOGIES = [
  "REDD+",
  "Reforestation",
  "Afforestation",
  "Managed Forestry (IFM)",
  "Blue Carbon",
  "Soil Carbon",
  "Biochar",
  "Methane Capture",
  "Renewable Energy",
  "Improved Cook Stoves",
  "Enhanced Rock Weathering",
  "Construction Carbon Sink",
  "Global Cooling Services",
] as const

export const KNOWN_REGIONS = [
  "South America", "Southeast Asia", "Africa", "Europe", "North America", "Oceania"
] as const

export const COUNTRY_TO_REGION: Record<string, string> = {
  Brazil: "South America",
  Colombia: "South America",
  Peru: "South America",
  Chile: "South America",
  Argentina: "South America",
  Kenya: "Africa",
  Tanzania: "Africa",
  Congo: "Africa",
  Ghana: "Africa",
  Ethiopia: "Africa",
  Indonesia: "Southeast Asia",
  Vietnam: "Southeast Asia",
  Thailand: "Southeast Asia",
  Malaysia: "Southeast Asia",
  Philippines: "Southeast Asia",
  Finland: "Europe",
  Sweden: "Europe",
  Germany: "Europe",
  Norway: "Europe",
  France: "Europe",
  Spain: "Europe",
  "United States": "North America",
  Canada: "North America",
  Mexico: "North America",
  Australia: "Oceania",
  "New Zealand": "Oceania",
}
